import { array, bool, func, object, shape, string } from 'prop-types'
import { Button } from '@opallabs/kuiper'
import { buildMenu } from './helpers'

import './styles.scss'

const popoverOptions = {
  hasCaret: true,
}

const ApprovalContextualMenu = ({
  approval,
  currentUser,
  onContextMenuAction,
  phase,
  workflowLocation,
}) => (
  <Button
    closeOnSelect={true}
    hideLabelText={true}
    icon="gem-settings"
    iconOptions={{
      height: 14,
      width: 14,
      ariaLabel: 'Manage approval',
      ariaRole: 'presentational',
      system: 'gem',
    }}
    label="Manage approval"
    noArrow={true}
    onSelect={onContextMenuAction}
    options={buildMenu(approval, currentUser, phase, workflowLocation)}
    popoverOptions={popoverOptions}
    tabIndex={-1}
    type="invisible"
  />
)

ApprovalContextualMenu.propTypes = {
  approval: shape({
    proxyUser: object,
    toUser: object,
  }).isRequired,
  currentUser: object,
  onContextMenuAction: func.isRequired,
  phase: shape({
    isActive: bool,
    isLocked: bool,
    items: array,
    status: string,
  }).isRequired,
  workflowLocation: string,
}

export default ApprovalContextualMenu
